import {useCallback} from 'react';
import {ICommonBannerWithPosition} from 'hooks/analytics/gtag/banners/useBannerViewGtag';

// глобальный Set для отслеживания просмотренных баннеров
// храним комбинацию id и position для уникальности
const globalViewedBanners = new Set<string>();

export const useBannerViewTracker = () => {
    const isBannerViewed = useCallback((banner: Partial<ICommonBannerWithPosition>): boolean => {
        const bannerKey = `${banner.id}_${banner.position || 1}`;
        return globalViewedBanners.has(bannerKey);
    }, []);

    const markBannerAsViewed = useCallback((banner: Partial<ICommonBannerWithPosition>): void => {
        const bannerKey = `${banner.id}_${banner.position || 1}`;
        globalViewedBanners.add(bannerKey);
    }, []);

    const clearViewedBanners = useCallback((): void => {
        globalViewedBanners.clear();
    }, []);

    return {
        isBannerViewed,
        markBannerAsViewed,
        clearViewedBanners,
    };
};
